<template>
  <div class="row">
    <transition name="fade" mode="out-in">
      <div class="col-lg-12" v-if="this.filters.length>0" name="filtersTable">
        <table class="table">
          <thead>
          <tr>
            <th>
              Filter
            </th>
            <th>
              Parameters
            </th>
            <th>
              Actions
            </th>
          </tr>
          </thead>
          <tbody name="fade" is="transition-group">
          <tr :key="index" v-for="(filter, index)  in filters">
            <td style="width: 15%">
              {{filter.typeName}}
            </td>
            <td>
              <component v-bind:is="`${filter.type}-params`" :filter="filter"/>
            </td>
            <td style="width:170px">
              <a @click.stop="onEdit(filter, index)" class="filter-row-icon edit-filter-icon"></a>
              <a @click.stop="onDelete(index)" class="filter-row-icon delete-filter-icon"></a>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div v-else key="noFiltersMessage" class="col-lg-12 text-center">
        <hr/>
        Begin by selecting the filters you want to apply to your search.<br/>
        Don't forget to specify a date range using Start, End or Active filters.
        Please note that you are also limited by any restrictions on your API Plan.
        <hr/>
      </div>
    </transition>
  </div>
</template>
<script>
  import Multiselect from 'vue-multiselect'
  import { FILTER_OPTIONS } from '@/app/wdc/form/fixtures'
  import fieldWrapper from '@/components/shared/field-wrapper'
  import categoryParams from '@/components/wdc/params/category'
  import countryParams from '@/components/wdc/params/country'
  import labelParams from '@/components/wdc/params/label'
  import stateParams from '@/components/wdc/params/state'
  import rankParams from '@/components/wdc/params/rank'
  import rankRangeParams from '@/components/wdc/params/rank-range'
  import localRankParams from '@/components/wdc/params/local-rank'
  import localRankRangeParams from '@/components/wdc/params/local-rank-range'
  import aviationRankParams from '@/components/wdc/params/aviation-rank'
  import aviationRankRangeParams from '@/components/wdc/params/aviation-rank-range'
  import queryParams from '@/components/wdc/params/query'
  import withinParams from '@/components/wdc/params/within'
  import placeParams from '@/components/wdc/params/place'
  import updatedParams from '@/components/wdc/params/updated'
  import activeParams from '@/components/wdc/params/active'
  import startParams from '@/components/wdc/params/start'
  import endParams from '@/components/wdc/params/end'
  import PhqAttendanceParams from '@/components/wdc/params/phq-attendance'

  export default {
    components: {
      Multiselect,
      fieldWrapper,
      categoryParams,
      countryParams,
      labelParams,
      stateParams,
      rankParams,
      rankRangeParams,
      localRankParams,
      localRankRangeParams,
      aviationRankParams,
      aviationRankRangeParams,
      queryParams,
      withinParams,
      updatedParams,
      activeParams,
      startParams,
      endParams,
      placeParams,
      PhqAttendanceParams
    },
    props: ['filters', 'onEdit', 'onDelete'],
    name: 'filterTable',
    data () {
      return {
        options: FILTER_OPTIONS
      }
    }
  }
</script>
<style>
</style>
